
const assert = require('assert');

const _ = require('lodash');
const ko = require('knockout');


function assertCheck (v, check) {
	if (_.isArray(check)) {
		const [ fn, msg ] = check;
		assert(fn(v), msg);
	} else {
		assert(check(v));
	}
}


ko.extenders.assert = function (target, options) {
	options = _.defaults({}, options, {
		read: [],
		write: [],
	});

	options.read = [].concat(options.read);
	options.write = [].concat(options.write);

	return ko.map(target, {
		mapRead: (v) => {
			_.each(options.read, (check) => {
				assertCheck(v, check);
			});
			return v;
		},
		mapWrite: (v) => {
			_.each(options.write, (check) => {
				assertCheck(v, check);
			});
			return v;
		},
	});
};
